export const showMobileBottomNavigation = (state) =>
  state.showMobileBottomNavigation;
